import { Fragment, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Divider } from "@mui/material";

import { ClientContent } from "../../../client-content/ClientContent";
import { useClientFileContext } from "../../../context/ClientFileContext";
import { useClaimOptions } from "../../hooks/useClaimOptions";
import { IncomeSectionCard } from "../income/components/income-section-card/IncomeSectionCard";
import { DETAIL_RIGHT_KINDS } from "./OtherPropertyRightsView.utils";
import { DetailRightsSection } from "./components/detail-rights-section/DetailRightsSection";
import { TenancyRightsSection } from "./components/tenancy-rights-section/TenancyRightsSection";
import { useAssetPropertyRights } from "./hooks/useAssetPropertyRights";

export function OtherPropertyRightsView() {
  const { t } = useTranslation();
  const { clientId } = useClientFileContext();
  const { formik, homeAddress, missingFields, onAddMove, onCancelMove } = useAssetPropertyRights(clientId);
  const claimReferences = useMemo(
    () =>
      formik.values.propertyRights.map(({ encumberedClaimId, encumberedCreditorName }) => ({
        claimId: encumberedClaimId,
        storedLabel: encumberedCreditorName,
      })),
    [formik.values.propertyRights]
  );
  const claimOptions = useClaimOptions(clientId, claimReferences);

  const documentProps = { clientId, formik, onAddMove, onCancelMove };

  return (
    <ClientContent formik={formik} missingFields={missingFields}>
      <IncomeSectionCard title={t("clients.client.debtSettlement.assetInventory.propertyRightsTab.title")}>
        <TenancyRightsSection {...documentProps} homeAddress={homeAddress} claimOptions={claimOptions} />
        {DETAIL_RIGHT_KINDS.map((config) => (
          <Fragment key={config.kind}>
            <Divider />
            <DetailRightsSection {...documentProps} config={config} />
          </Fragment>
        ))}
      </IncomeSectionCard>
    </ClientContent>
  );
}
